import { render, staticRenderFns } from "./TheInvestmentsDashboard.vue?vue&type=template&id=253232c8&"
import script from "./TheInvestmentsDashboard.vue?vue&type=script&lang=js&"
export * from "./TheInvestmentsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports